import classnames from 'classnames';
import { SfaScorerRowProps } from './sfaScorerRow.types';
import styles from './sfaScorerRow.module.scss';

const SfaScorerRow = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-scorer-row',
  icon,
  time,
  playerName,
  alignment = 'home',
  preserveIconColor = false,
}: SfaScorerRowProps) => {
  const alignmentClass =
    alignment === 'away'
      ? styles['sfaScorerRow--away']
      : styles['sfaScorerRow--home'];

  return (
    <div
      {...nativeProps}
      data-testid={testId}
      className={classnames(styles.sfaScorerRow, alignmentClass, classNames)}
    >
      {icon ? (
        <span
          className={classnames(
            styles.icon,
            preserveIconColor && styles['icon--originalColor']
          )}
        >
          {icon}
        </span>
      ) : null}
      <span className={styles.time}>{time}</span>
      <span className={styles.playerName}>{playerName}</span>
    </div>
  );
};

export default SfaScorerRow;
